import { css } from '@emotion/react';
import * as React from 'react';
import { ReactNode } from 'react';

interface Props {
  title: string | ReactNode;
  imgSrc: string; // Added imgSrc prop to pass the image source
  className?: string;
  children?: React.ReactNode;
}

export const CongratulationThankYouLayout: React.FC<Props> = (props) => {
  const { className, imgSrc, children, title } = props;
  return (
    <div className={className} css={wrapperCss}>
      <img src={imgSrc} alt="" css={imageCss} />
      <h1 css={headerCss}>{title}</h1>
      <div css={buttonsContainerCss}>{children}</div>
    </div>
  );
};

const wrapperCss = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  max-width: 100%;
`;

const headerCss = css`
  font:
    700 28px/36px Roboto,
    sans-serif;
  text-transform: none;
  text-align: center;
`;

const buttonsContainerCss = css`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 24px;
`;

const imageCss = css`
  width: auto;
  height: 128px;
`;
